module.exports = __webpack_public_path__ + "img/banner_store_coop1.09d5a065.jpg";